import React from "react";
import Slide from "react-reveal/Slide";

import { ANIMATION_DURATION } from "../../Misc/Constants";

interface IDropDownCard {
  children: any;
}

export default function DropDownCard(props: IDropDownCard) {
  return (
    //TODO: Fix Scrolling Visual Issues
    <div className="absolute inset-x-0 origin-top top-[85%] z-10 rounded-2xl overflow-clip w-full">
      {/* TODO FIX SLIDE ANIMATION REPEATED */}
      <Slide top duration={ANIMATION_DURATION}>
        <div className="w-full flex flex-col bg-brij-White z-10 rounded-b-2xl rounded-tr-2xl divide-y-2 divide-brij-LightGrey border-2 border-brij-LightGrey max-h-64 overflow-scroll">
          {props.children}
        </div>
      </Slide>
    </div>
  );
}
